import { motion } from "framer-motion";
import type { ReactNode } from "react";
import { usePrefersReducedMotion } from "@/components/home/usePrefersReducedMotion";

/**
 * 스크롤 리빌 래퍼 (home-ui-spec §7.2·§8, 자체 구현). opacity 0→1 + y 24→0,
 * 600ms, --ty-ease, 20% 가시 1회성. reduced-motion 시 즉시 표시(§7.4).
 */
export interface RevealProps {
  children: ReactNode;
  /** 형제 stagger 지연 ms — 60ms 간격, 최대 4개까지(§7.2) */
  delay?: number;
  className?: string;
}

export function Reveal({ children, delay = 0, className }: RevealProps) {
  const reduced = usePrefersReducedMotion();
  if (reduced) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: delay / 1000 }}
    >
      {children}
    </motion.div>
  );
}
